import { CC_APPLICATION_IDENTITY } from '../constants';

type UserIdentity = {
  firstName: string;
  lastName: string;
  dateOfBirth: string;
  isVerified: boolean;
};

export const getUserIdentityFromSessionStorage = () => {
  const userIdentity = window.sessionStorage?.getItem(CC_APPLICATION_IDENTITY);
  return JSON.parse(userIdentity);
};

export const setUserIdentityToSessionStorage = (
  userIdentity: UserIdentity
): void => {
  window.sessionStorage.setItem(
    CC_APPLICATION_IDENTITY,
    JSON.stringify(userIdentity)
  );
};

export const removeIdentityToSessionStorage = (): void => {
  window.sessionStorage.removeItem(CC_APPLICATION_IDENTITY);
};

export const setIdentityIsVerifyFieldToSessionStorage = (
  isVerified: boolean
) => {
  const currentData = getUserIdentityFromSessionStorage();
  currentData.isVerified = isVerified;
  setUserIdentityToSessionStorage(currentData);
};

export const Logout = (redirect_uri = '') => {
  const redirectUri =
    redirect_uri || window.location.pathname + window.location.search;
  window.location.assign(
    `/auth/signout?redirect_uri=${encodeURIComponent(redirectUri)}`
  );
};
